// Service worker helpers.
// App-shell / Workbox caching is disabled; only firebase-messaging-sw.js is kept.

const FCM_SW_FILE = "firebase-messaging-sw.js";
const RELOAD_FLAG = "lmp-sw-cleanup-reload";

function getRegistrationScriptURL(registration) {
  return (
    registration.active?.scriptURL ||
    registration.waiting?.scriptURL ||
    registration.installing?.scriptURL ||
    ""
  );
}

function isFcmScriptURL(scriptURL) {
  return Boolean(scriptURL) && scriptURL.includes(FCM_SW_FILE);
}

/**
 * Remove leftover CRA/Workbox SWs and their Cache Storage so deploys load
 * without users needing "Clear data". Keeps Firebase messaging SW.
 */
export async function cleanupStalePwaCaches() {
  if (!("serviceWorker" in navigator)) return;

  let shouldReload = false;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();

    await Promise.all(
      registrations.map(async (registration) => {
        const scriptURL = getRegistrationScriptURL(registration);
        if (isFcmScriptURL(scriptURL)) return;

        const controller = navigator.serviceWorker.controller;
        const wasControlling =
          Boolean(controller) &&
          (!scriptURL ||
            controller.scriptURL === scriptURL ||
            registration.active === controller);

        await registration.unregister();
        if (wasControlling) shouldReload = true;
      })
    );

    const controller = navigator.serviceWorker.controller;
    if (controller && !isFcmScriptURL(controller.scriptURL)) {
      shouldReload = true;
    }

    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(
        keys
          .filter((key) =>
            /workbox|precache|runtime-caching|cra-/i.test(key)
          )
          .map((key) => caches.delete(key))
      );
    }
  } catch (_) {
    // Best-effort cleanup; never block app boot.
  }

  if (!shouldReload) return;

  try {
    if (!sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, "1");
      window.location.reload();
    }
  } catch (_) {
    // sessionStorage may be blocked; skip reload loop protection.
  }
}

export function register(config) {
  if (!("serviceWorker" in navigator)) return;

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  registerValidSW(swUrl, config);
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state !== "installed") return;
          if (navigator.serviceWorker.controller) {
            if (config?.onUpdate) config.onUpdate(registration);
          } else if (config?.onSuccess) {
            config.onSuccess(registration);
          }
        };
      };
    })
    .catch(() => {});
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
